/**
 * Vori (ভরি) — traditional Bangladeshi unit for gold/silver.
 * Single source of truth: 1 vori = 11.664 g (16 ana, 96 rotti).
 */
export const GRAMS_PER_VORI = 11.664;

export function voriToGrams(vori: number): number {
  return vori * GRAMS_PER_VORI;
}

export function gramsToVori(grams: number): number {
  return grams / GRAMS_PER_VORI;
}
